import React from 'react';
import styles from './Loading.module.css';
import LogoConLetras from './LogoConLetras.png';

const Loading = () => {
    return (
        <div className={styles.container}>
            <div className={styles.rectWhite}></div>
            <div className={styles.imageContainer}>
                <img src={LogoConLetras} className={styles.image} alt="Logo"></img>
            </div>
            <div className={styles.circle}></div>
            
        </div>
    );
};

export default Loading;
